import axios, { AxiosResponse } from 'axios';
import { apiClient } from './apiClient';

export interface Job {
    _id: string;
    designation: string;
    order?: number;
    displayOrder?: number;
    crudStatus: number;
    price: number;
    priceType: number;
    hasTravelZones: boolean;
    hasMealAllowance: boolean;
    hasPhoneAllowance: boolean;
    usageCount?: {
        total: number;
        users: number;
    };
    updatedAt?: string;
    createdAt?: string;
}

interface JobsResponse {
    message: string;
    data: Job[];
}

export interface GetJobsQueries {
    active?: boolean;
    withUsage?: boolean;
}

export const getAllJobs = async (queries?: GetJobsQueries): Promise<JobsResponse> => {
    try {
        const response: AxiosResponse<JobsResponse> = await apiClient.get('/jobs', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateJobBody {
    designation?: string;
    order?: number;
    displayOrder?: number | null;
    crudStatus?: number;
    price?: number;
    priceType?: number;
    hasTravelZones?: boolean;
    hasMealAllowance?: boolean;
    hasPhoneAllowance?: boolean;
}

export interface JobResponse {
    message: string;
    data: Job;
}

export const updateJob = async (jobId: string, data: UpdateJobBody): Promise<JobResponse> => {
    try {
        const response: AxiosResponse<JobResponse> = await apiClient.patch('/jobs/' + jobId, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateJobBody {
    designation: string;
    order?: number;
    displayOrder?: number | null;
    crudStatus?: number;
    price: number;
    priceType: number;
    hasTravelZones: boolean;
    hasMealAllowance: boolean;
    hasPhoneAllowance: boolean;
}

export const createJob = async (data: CreateJobBody): Promise<JobResponse> => {
    try {
        const response: AxiosResponse<JobResponse> = await apiClient.post('/jobs', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
